<template>
  <el-dialog width="40%" ref="dialog" :visible.sync="localVisible" @close="close">
    <div slot="title">{{ title }}</div>

    <div>{{ message }}</div>

    <v-row slot="footer" justify="between">
      <v-button theme="primary" view="transparent" @click="cancel">{{ $t('c.dialog.buttonCancel') }}</v-button>
      <v-button theme="primary" @click="confirm">{{ $t('c.dialog.buttonConfirm') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VRow from '@/components/common/VRow.vue'
import visibleMixin from '@/mixins/visible'

export default {
  name: 'VConfirmationDialog',

  mixins: [visibleMixin],
  components: { VRow },

  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel')
      this.close()
    },
    confirm() {
      this.$emit('confirm')
      this.close()
    }
  }
}
</script>
